module.exports = __webpack_public_path__ + "static/media/SharpSansNo2-Semibold.0e452f00.otf";